import classNames from "classnames";
// import { Box, Stack } from "@fastlooptech/layout-components";
import { spaceUnit } from "@/helpers/utils.helper";
import { Body, Heading } from "@/client/foundations/Typography";
import { CarouselComponent } from "@/blocks/Carousel/Carousel";
import { useResponsive } from "@/client/hooks/useResponsive";
// import { renderToString } from "react-dom/server";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { Box, Stack } from "@/layouts/LayoutComponents";
import ImageWrapper from "@/components/ImageWrapper";
import ContentfulRichText from "@/server/ContentfulRichText";

export default function EditorialSlider(props: any) {
  const { id, title, description, image, badge } = props;
  const { isXl } = useResponsive();

  const badgeImage = {
    width: 172,
    height: 172,
    src: badge ? (badge + "?fit=fill&f=center") : "https://placehold.co/172"
  }

  const imagePlaceholder = {
    width: 800,
    height: 1062,
    src: image ? (image + "?fit=fill&f=center") : "https://placehold.co/800x1062"
  }

  const isInFrame = (typeof window !== "undefined") && window.self !== window.top;

  return (
    <div className="relative !block w-screen no-scrollbar" id={id}>
      <Box
        data-test-id={props["data-test-id"]}
        vAlignContent="top"
        hAlignContent="center"
        className={classNames("relative w-full no-scrollbar max-w-[1440px] m-auto", props.className)}
        column={!isXl}
      >
        {isXl && (
          <ImageWrapper
            data-test-id={props["data-test-id"] + "-badge"}
            alt={props["data-test-id"] + "-badge"}
            src={badgeImage.src}
            placeholder="blur"
            blurDataURL={badgeImage.src}
            width={badgeImage.width}
            height={badgeImage.height}
            priority
            // loading="lazy"
            loader={({ src }) => src}
            className="absolute -top-5 !right-[650px] z-[1]"
            data-aos="fade-in"
          />
        )}
        <Stack
          gap={spaceUnit * 3}
          column
          className={classNames("xl:w-2/4", {
            "px-2": !isXl,
            "px-[120px] pt-[120px]": isXl,
          })}
        >
          <Heading size="xl" animated={true}>{title}</Heading>
          <Body size="l"
            animated={true}>{description}</Body>
        </Stack>
        {isXl && (
          <ImageWrapper
            data-test-id={props["data-test-id"] + "-image"}
            alt={props["data-test-id"] + "-image"}
            src={imagePlaceholder.src}
            placeholder="blur"
            blurDataURL={imagePlaceholder.src}
            width={imagePlaceholder.width}
            height={imagePlaceholder.height}
            priority
            // loading="lazy"
            loader={({ src }) => src}
            className="pt-5 xl:w-2/4 aspect-2/3"
            data-aos="fade-in"
          />
        )}
      </Box>

      <CarouselComponent
        className={classNames("min-w-[20%] max-w-[100%]", isXl ? "w-screen absolute !bottom-18 !left-0" : "relative pt-5")}>
        {isInFrame ? <div className="w-[800px]">
          {props.children}
        </div> : props.children}
      </CarouselComponent>

    </div>
  );
}